<template>
    <div class="graduateRegistForm">
        <div v-if="isSubmit" class="info">
            <div class="info-box">
                <div class="title-box">重庆医科大学高等学历继续教育毕业生登记表</div>
                <!-- label-width="80px" -->
                <el-form 
                    ref="form" 
                    :model="formData" 
                    :rules="rules"
                >
                    <div class="info-floor">
                        <div class="item">
                            <span class="name">学号:</span>
                            <el-input class="input" v-model="userInfo.student_code" readonly placeholder=""></el-input>
                        </div>
                        <div class="item">
                            <span class="name">年级:</span>
                            <el-input class="input" v-model="userInfo.grade" readonly placeholder=""></el-input>
                        </div>
                        <div class="item">
                            <span class="name">学习形式:</span>
                            <el-input class="input" v-model="userInfo.study_form_title" readonly placeholder=""></el-input>
                        </div>
                    </div>
                    <div class="info-floor">
                        <div class="item">
                            <span class="name">专业:</span>
                            <el-input class="input" v-model="userInfo.profession_title" readonly placeholder=""></el-input>
                        </div>
                    </div>
                    <div class="table-box">
                        <table class="table-item">
                            <tbody>
                                <tr>
                                    <td class="cell table-name" rowspan="8">
                                        <p>学</p>
                                        <p>生</p>
                                        <p>本</p>
                                        <p>人</p>
                                        <p>基</p>
                                        <p>本</p>
                                        <p>情</p>
                                        <p>况</p>
                                    </td>
                                    <td class="cell name" style="width: 13%;">姓名</td>
                                    <td class="cell" colspan="2" style="width: 16%;">{{ userInfo.student_title }}</td>
                                    <td class="cell name" style="width: 10%;">性别</td>
                                    <td class="cell">{{ userInfo.sex_title }}</td>
                                    <td class="cell name" style="width: 10%;">民族</td>
                                    <td class="cell" style="width: 18%;">{{ userInfo.nation }}</td>
                                    <td class="cell avatar" rowspan="5" style="width: 200px;">
                                        <el-image
                                            v-if="userInfo.admission_img"
                                            :src="userInfo.admission_img"
                                            fit="contain"
                                        ></el-image>
                                        <div v-else>
                                            <p>贴</p>
                                            <p>正</p>
                                            <p>面</p>
                                            <p>头</p>
                                            <p>像</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell">政治面貌</td>
                                    <td class="cell" colspan="2">
                                        <!-- {{ userInfo.political_status }} -->
                                        <el-form-item label="" prop="political_status">
                                            <el-select v-model="formData.political_status" placeholder="请选择政治面貌" clearable filterable style="width: 100%;">
                                                <el-option
                                                    v-for="(item, index) in outlookList"
                                                    :key="index"
                                                    :label="item.title"
                                                    :value="item.id"
                                                    >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">学制</td>
                                    <td class="cell" colspan="3">{{ userInfo.education_length }}</td>
                                    <!-- <td class="cell" colspan="2"></td> -->
                                    <!-- <td class="cell" colspan="2">
                                        <el-form-item label="" prop="hkmo_tw_occupant">
                                            <el-radio-group v-model="formData.hkmo_tw_occupant">
                                                <el-radio label="1">港</el-radio>
                                                <el-radio label="2">澳</el-radio>
                                                <el-radio label="3">台</el-radio>
                                                <el-radio label="4">侨</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td class="cell">出生日期</td>
                                    <td class="cell" colspan="2">{{ userInfo.birth_date }}</td>
                                    <td class="cell required">毕业时间</td>
                                    <td class="cell" colspan="3">
                                        {{ userInfo.graduate_time }}
                                        <!-- <el-form-item label="" prop="graduate_time">
                                            <el-date-picker
                                                v-model="formData.graduate_time"
                                                type="date"
                                                placeholder="请填写毕业时间"
                                                format="yyyy年MM月dd日"
                                                value-format="yyyy-MM-dd"
                                                style="width:100%" 
                                            >
                                            </el-date-picker>
                                        </el-form-item> -->
                                    </td>
                                    <!-- <td class="cell" colspan="2">健康状况</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="health_status">
                                            <el-radio-group v-model="formData.health_status">
                                                <el-radio label="1">健康</el-radio>
                                                <el-radio label="2">残疾</el-radio>
                                                <el-radio label="3">其他</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td class="cell">学历层次</td>
                                    <td class="cell" colspan="2">{{ userInfo.education_level_title }}</td>
                                    <td class="cell">身份证号</td>
                                    <td class="cell" colspan="3">{{ userInfo.id_card }}</td>
                                </tr>
                                <tr>
                                    <!-- rowspan="2" -->
                                    <td class="cell required">工作信息</td>
                                    <td class="cell" colspan="4">
                                        <el-form-item label="" prop="work_info">
                                            <el-input v-model="formData.work_info" clearable placeholder="" maxlength="22" show-word-limit></el-input>
                                        </el-form-item>
                                    </td>
                                    <!-- <td class="cell" colspan="2">
                                        <el-form-item label="现工作单位:" label-width="100px" prop="current_work_unit">
                                            <el-input v-model="formData.current_work_unit" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td> -->
                                    <td class="cell" colspan="2">
                                        <div style="display: flex;">
                                            <el-form-item label="职务:" label-width="80px" prop="position">
                                                <el-input v-model="formData.position" clearable placeholder="" maxlength="10" show-word-limit></el-input>
                                            </el-form-item>
                                            <el-form-item label="职称:" label-width="80px" prop="job_title">
                                                <el-input v-model="formData.job_title" clearable placeholder="" maxlength="10" show-word-limit></el-input>
                                            </el-form-item>
                                        </div>
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td class="cell">
                                        <el-form-item label="邮编:" label-width="50px" prop="postal_code">
                                            <el-input v-model="formData.postal_code" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr> -->
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name" rowspan="3">
                                        <p>通</p>
                                        <p>讯</p>
                                        <p>录</p>
                                    </td>
                                    <td class="cell name required" rowspan="2" style="width: 100px;">详细通讯地址</td>
                                    <td class="cell" rowspan="2" colspan="4">
                                        <el-form-item label="" prop="detailed_address">
                                            <el-input v-model="formData.detailed_address" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell name">邮政编码</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="address_postal_code">
                                            <el-input v-model="formData.address_postal_code" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell name required">电子邮箱</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="email">
                                            <el-input v-model="formData.email" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell name">手机号</td>
                                    <td class="cell" colspan="2">
                                         {{ userInfo.mobile_phone }}
                                        <!-- <el-form-item label="" prop="mobile_phone">
                                            <el-input v-model="formData.mobile_phone" readonly clearable placeholder=""></el-input>
                                        </el-form-item> -->
                                    </td>
                                    <td class="cell name">座机</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="landline">
                                            <el-input v-model="formData.landline" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell name required">QQ号</td>
                                    <td class="cell">
                                        <el-form-item label="" prop="qq_number">
                                            <el-input v-model="formData.qq_number" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name" :rowspan="formData.personal_resume.length + 1">
                                        <p>个</p>
                                        <p>人</p>
                                        <p>主</p>
                                        <p>要</p>
                                        <p>简</p>
                                        <p>历</p>
                                    </td>
                                    <td class="cell name" colspan="3">何年何月-何年何月</td>
                                    <td class="cell name" colspan="3">在何地工作或学习</td>
                                    <td class="cell name">任职情况</td>
                                    <td class="cell name">备注</td>
                                </tr>
                                <tr v-for="(item, index) in formData.personal_resume" :key="index">
                                    <td class="cell" colspan="3">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.time" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell" colspan="3">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.cont" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.situation" clearable placeholder="" maxlength="15" show-word-limit></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.remark" clearable placeholder="" maxlength="10" show-word-limit></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name">
                                        <p>毕</p>
                                        <p>业</p>
                                        <p>生</p>
                                        <p>自</p>
                                        <p>我</p>
                                        <p>鉴</p>
                                        <p>定</p>
                                    </td>
                                    <td class="cell" colspan="8">
                                        <div>
                                            <p>对在读期间的思想政治道德、学习、工作、遵纪守法等方面进行总结。（600字以内）</p>
                                            <div style="margin-top: 20px; height: 200px;">
                                                <el-form-item label="" prop="graduate_self_evaluation">
                                                    <el-input
                                                        type="textarea"
                                                        resize="none"
                                                        v-model="formData.graduate_self_evaluation"
                                                        placeholder=""
                                                        maxlength="600" show-word-limit
                                                        rows="8"
                                                        clearable
                                                    ></el-input>
                                                </el-form-item>
                                            </div>
                                            <div>
                                                <div class="esign-info-box">
                                                    <div class="esign-box">
                                                        <el-form-item label="学生签名：" label-width="120px" prop="graduate_self_sign">
                                                            <!-- this.$refs['esignHandle'].handleReset(); -->
                                                            <esignHandle
                                                                ref="esignHandle"
                                                                :selectSignImg.sync="formData.graduate_self_sign"
                                                            ></esignHandle>
                                                        </el-form-item>
                                                    </div>
                                                    <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                        <!-- <span>填表时间:</span> -->
                                                        <!-- <span style="margin-left: 10px;">{{ formData.fill_date }}</span> -->
                                                        <div style="width: 300px;">
                                                            <el-form-item label="填表时间:" label-width="120px" prop="graduate_self_date">
                                                                <el-date-picker
                                                                    v-model="formData.graduate_self_date"
                                                                    type="date"
                                                                    placeholder="请填写填表时间"
                                                                    format="yyyy年MM月dd日"
                                                                    value-format="yyyy-MM-dd"
                                                                    style="width:100%" 
                                                                >
                                                                </el-date-picker>
                                                            </el-form-item>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name">
                                        <p>班</p>
                                        <p>级</p>
                                        <p>意</p>
                                        <p>见</p>
                                    </td>
                                    <td class="cell" colspan="8">
                                        <div>
                                            <p style="height: 100px;"></p>
                                            <div style="margin-top: 20px;">
                                                <!-- <el-form-item label="" prop="graduate_self_evaluation">
                                                    <el-input
                                                        type="textarea"
                                                        resize="none"
                                                        v-model="formData.first_audit_content"
                                                        placeholder=""
                                                        maxlength="600" show-word-limit
                                                        rows="10px"
                                                        clearable
                                                    ></el-input>
                                                </el-form-item> -->
                                            </div>
                                            <div>
                                                <div class="esign-info-box">
                                                    <div class="esign-box">
                                                        <span style="margin-right: 140px;">班级负责人签字：</span>
                                                        <!-- <el-form-item label="班级负责人签字：" label-width="140px" prop="sign_img">
                                                            <esignHandle
                                                                ref="esignHandle"
                                                                :selectSignImg.sync="formData.sign_img"
                                                            ></esignHandle>
                                                        </el-form-item> -->
                                                    </div>
                                                    <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                        <!-- <span>填表时间:</span> -->
                                                        <!-- <span style="margin-left: 10px;">{{ formData.fill_date }}</span> -->
                                                        <div style="width: 200px;">
                                                            <span>年</span>
                                                            <span style="margin: 0 40px;">月</span>
                                                            <span>日</span>
                                                            <!-- <el-form-item label="填表时间:" label-width="120px" prop="fill_date">
                                                                <el-date-picker
                                                                    v-model="formData.fill_date"
                                                                    type="date"
                                                                    placeholder="请填写填表时间"
                                                                    format="yyyy年MM月dd日"
                                                                    value-format="yyyy-MM-dd"
                                                                    style="width:100%" 
                                                                >
                                                                </el-date-picker>
                                                            </el-form-item> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name">
                                        <p>科</p>
                                        <p>室</p>
                                        <p>意</p>
                                        <p>见</p>
                                    </td>
                                    <td class="cell" colspan="8">
                                        <div>
                                            <p style="height: 100px;"></p>
                                            <div style="margin-top: 20px;">
                                                <!-- <el-form-item label="" prop="graduate_self_evaluation">
                                                    <el-input
                                                        type="textarea"
                                                        resize="none"
                                                        v-model="formData.first_audit_content"
                                                        placeholder=""
                                                        maxlength="600" show-word-limit
                                                        rows="10px"
                                                        clearable
                                                    ></el-input>
                                                </el-form-item> -->
                                            </div>
                                            <div>
                                                <div class="esign-info-box">
                                                    <div class="esign-box">
                                                        <span style="margin-right: 140px;">负责人签字（公章）：</span>
                                                        <!-- <el-form-item label="班级负责人签字：" label-width="140px" prop="sign_img">
                                                            <esignHandle
                                                                ref="esignHandle"
                                                                :selectSignImg.sync="formData.sign_img"
                                                            ></esignHandle>
                                                        </el-form-item> -->
                                                    </div>
                                                    <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                        <!-- <span>填表时间:</span> -->
                                                        <!-- <span style="margin-left: 10px;">{{ formData.fill_date }}</span> -->
                                                        <div style="width: 200px;">
                                                            <span>年</span>
                                                            <span style="margin: 0 40px;">月</span>
                                                            <span>日</span>
                                                            <!-- <el-form-item label="填表时间:" label-width="120px" prop="fill_date">
                                                                <el-date-picker
                                                                    v-model="formData.fill_date"
                                                                    type="date"
                                                                    placeholder="请填写填表时间"
                                                                    format="yyyy年MM月dd日"
                                                                    value-format="yyyy-MM-dd"
                                                                    style="width:100%" 
                                                                >
                                                                </el-date-picker>
                                                            </el-form-item> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name">
                                        <p>学</p>
                                        <p>校</p>
                                        <p>主</p>
                                        <p>管</p>
                                        <p>部</p>
                                        <p>门</p>
                                        <p>意</p>
                                        <p>见</p>
                                    </td>
                                    <td class="cell" colspan="8">
                                        <div>
                                            <p style="height: 100px;"></p>
                                            <div style="margin-top: 20px;">
                                                <!-- <el-form-item label="" prop="graduate_self_evaluation">
                                                    <el-input
                                                        type="textarea"
                                                        resize="none"
                                                        v-model="formData.first_audit_content"
                                                        placeholder=""
                                                        maxlength="600" show-word-limit
                                                        rows="10px"
                                                        clearable
                                                    ></el-input>
                                                </el-form-item> -->
                                            </div>
                                            <div>
                                                <div class="esign-info-box">
                                                    <div class="esign-box">
                                                        <span style="margin-right: 140px;">主管部门（公章）：</span>
                                                        <!-- <el-form-item label="班级负责人签字：" label-width="140px" prop="sign_img">
                                                            <esignHandle
                                                                ref="esignHandle"
                                                                :selectSignImg.sync="formData.sign_img"
                                                            ></esignHandle>
                                                        </el-form-item> -->
                                                    </div>
                                                    <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                        <!-- <span>填表时间:</span> -->
                                                        <!-- <span style="margin-left: 10px;">{{ formData.fill_date }}</span> -->
                                                        <div style="width: 200px;">
                                                            <span>年</span>
                                                            <span style="margin: 0 40px;">月</span>
                                                            <span>日</span>
                                                            <!-- <el-form-item label="填表时间:" label-width="120px" prop="fill_date">
                                                                <el-date-picker
                                                                    v-model="formData.fill_date"
                                                                    type="date"
                                                                    placeholder="请填写填表时间"
                                                                    format="yyyy年MM月dd日"
                                                                    value-format="yyyy-MM-dd"
                                                                    style="width:100%" 
                                                                >
                                                                </el-date-picker>
                                                            </el-form-item> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="margin-top: 20px;text-align: center;padding-right: 50px;">重庆医科大学继续教育学院制</div>
                    </div>
                </el-form>
            </div>
            <div class="btn-box">
                <el-button type="primary" @click="confirmClick">提交</el-button>
                <!-- <el-button class="exit-btn" type="primary" @click="exit">退出登录</el-button> -->
            </div>
        </div>
        <div v-else class="info">
            <div class="graduateRegistForm-student-info-box" ref="student-info-print">
                <div class="title-box">重庆医科大学高等学历继续教育毕业生登记表</div>
                <div class="info-floor">
                    <div class="item">
                        <span class="name">学号:</span>
                        <el-input class="input" v-model="detailData.student_code" readonly placeholder=""></el-input>
                    </div>
                    <div class="item" style="width: 120px;">
                        <span class="name">年级:</span>
                        <el-input class="input" v-model="detailData.grade" readonly placeholder=""></el-input>
                    </div>
                    <div class="item" style="width: 150px;">
                        <span class="name">学习形式:</span>
                        <el-input class="input" v-model="detailData.study_form_title" readonly placeholder=""></el-input>
                    </div>
                    <div class="item" style="flex: 1;">
                        <span class="name">专业:</span>
                        <el-input class="input" v-model="detailData.profession_title" readonly placeholder=""></el-input>
                    </div>
                </div>
                <div class="table-box">
                    <table class="table-item">
                        <tbody>
                            <tr>
                                <td class="cell table-name" rowspan="8">
                                    <p>学</p>
                                    <p>生</p>
                                    <p>本</p>
                                    <p>人</p>
                                    <p>基</p>
                                    <p>本</p>
                                    <p>情</p>
                                    <p>况</p>
                                </td>
                                <td class="cell name" style="width: 13%;">姓名</td>
                                <td class="cell" colspan="2" style="width: 16%;">{{ detailData.student_title }}</td>
                                <td class="cell name" style="width: 10%;">性别</td>
                                <td class="cell">{{ detailData.sex | sexFilter }} </td>
                                <td class="cell name" style="width: 10%;">民族</td>
                                <td class="cell" style="width: 18%;">{{ detailData.nation }}</td>
                                <td class="cell avatar" rowspan="5">
                                    <el-image
                                        v-if="detailData.admission_img"
                                        :src="detailData.admission_img"
                                        fit="contain"
                                    ></el-image>
                                    <div v-else>
                                        <p>贴</p>
                                        <p>正</p>
                                        <p>面</p>
                                        <p>头</p>
                                        <p>像</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="cell">政治面貌</td>
                                <td class="cell" colspan="2"> {{ detailData.political_status }}</td>
                                <td class="cell">学制</td>
                                <td class="cell" colspan="3">{{ detailData.education_length }}</td>
                                <!-- <td class="cell" colspan="2">
                                    <el-radio-group v-model="detailData.hkmo_tw_occupant" disabled>
                                        <el-radio 
                                            v-for="(item, index) in hkmoTwOccupantData" 
                                            :key="index" 
                                            :label="item.id"
                                        >{{ item.title }}</el-radio>
                                    </el-radio-group>
                                </td> -->
                            </tr>
                            <tr>
                                <td class="cell">出生日期</td>
                                <td class="cell" colspan="2">{{ detailData.birth_date }}</td>
                                <td class="cell">毕业时间</td>
                                <td class="cell" colspan="3">
                                    {{ detailData.graduate_time }}
                                </td>
                                <!-- <td class="cell" colspan="2">健康状况</td> -->
                                <!-- <td class="cell" colspan="2">
                                    <el-radio-group v-model="detailData.health_status" disabled>
                                        <el-radio 
                                            v-for="(item, index) in healthStatusData" 
                                            :key="index" 
                                            :label="item.id"
                                        >{{ item.title }}</el-radio>
                                    </el-radio-group>
                                </td> -->
                            </tr>
                            <tr>
                                <td class="cell">学历层次</td>
                                <td class="cell" colspan="2">{{ detailData.education_level | educationLevelFilter }}</td>
                                <td class="cell">身份证号</td>
                                <td class="cell" colspan="3">{{ detailData.id_card }}</td>
                            </tr>
                            <tr>
                                <!-- rowspan="2" -->
                                <td class="cell">工作信息</td>
                                <td class="cell" colspan="4">{{ detailData.work_info }}</td>
                                <!-- <td class="cell" colspan="2">现工作单位: {{ detailData.current_work_unit }}</td> -->
                                <td class="cell" colspan="2">
                                    <div style="display: flex;">
                                        <span style="margin-right: 10px;">职务: {{ detailData.position }}</span>
                                        <span>职称: {{ detailData.job_title }}</span>
                                    </div>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td class="cell">邮编: {{ detailData.postal_code }}</td>
                            </tr> -->
                        </tbody>
                        <tbody>
                            <tr>
                                <td class="cell table-name" rowspan="3">
                                    <p>通</p>
                                    <p>讯</p>
                                    <p>录</p>
                                </td>
                                <td class="cell name" rowspan="2" style="width: 100px;">详细通讯地址</td>
                                <td class="cell" rowspan="2" colspan="4">{{ detailData.detailed_address }}</td>
                                <td class="cell name">邮政编码</td>
                                <td class="cell" colspan="2">{{ detailData.address_postal_code }}</td>
                            </tr>
                            <tr>
                                <td class="cell name">电子邮箱</td>
                                <td class="cell" colspan="2">{{ detailData.email }}</td>
                            </tr>
                            <tr>
                                <td class="cell name">手机号</td>
                                <td class="cell" colspan="2">{{ detailData.mobile_phone }}</td>
                                <td class="cell name">座机</td>
                                <td class="cell" colspan="2">{{ detailData.landline }}</td>
                                <td class="cell name">QQ号</td>
                                <td class="cell">{{ detailData.qq_number }}</td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td class="cell table-name" :rowspan="detailData.personal_resume.length + 1">
                                    <p>个</p>
                                    <p>人</p>
                                    <p>主</p>
                                    <p>要</p>
                                    <p>简</p>
                                    <p>历</p>
                                </td>
                                <td class="cell name" colspan="3" style="height: 34px;">何年何月-何年何月</td>
                                <td class="cell name" colspan="3">在何地工作或学习</td>
                                <td class="cell name">任职情况</td>
                                <td class="cell name">备注</td>
                            </tr>
                            <tr v-for="(item, index) in detailData.personal_resume" :key="index">
                                <td class="cell" colspan="3" style="height: 34px;">{{ item.time }}</td>
                                <td class="cell" colspan="3">{{ item.cont }}</td>
                                <td class="cell">{{ item.situation }}</td>
                                <td class="cell">{{ item.remark }}</td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td class="cell table-name">
                                    <p>毕</p>
                                    <p>业</p>
                                    <p>生</p>
                                    <p>自</p>
                                    <p>我</p>
                                    <p>鉴</p>
                                    <p>定</p>
                                </td>
                                <td class="cell" colspan="8">
                                    <div>
                                        <p>对在读期间的思想政治道德、学习、工作、遵纪守法等方面进行总结。（600字以内）</p>
                                        <div style="margin-top: 20px;min-height: 200px;">
                                            <span style="white-space: pre-wrap;">{{ detailData.graduate_self_evaluation }}</span>
                                        </div>
                                        <div>
                                            <div class="esign-info-box">
                                                <div class="esign-box">
                                                    <span>学生签名：</span>
                                                    <el-image
                                                        v-if="detailData.graduate_self_sign"
                                                        :src="detailData.graduate_self_sign"
                                                        fit="cover"
                                                        style="width: 80px;margin-left: 40px;"
                                                    ></el-image>
                                                </div>
                                                <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                    <div style="width: 200px;">
                                                        <!-- <span>填表时间:</span> -->
                                                        <span style="margin-left: 10px;">{{ detailData.graduate_self_date }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td class="cell table-name">
                                    <p>班</p>
                                    <p>级</p>
                                    <p>意</p>
                                    <p>见</p>
                                </td>
                                <td class="cell" colspan="8">
                                    <div>
                                        <p style="height: 100px;"></p>
                                        <div style="margin-top: 20px;">
                                            {{ detailData.class_opinions }}
                                        </div>
                                        <div>
                                            <div class="esign-info-box">
                                                <div class="esign-box">
                                                    <span style="margin-right: 120px;">班级负责人签字：</span>
                                                    <el-image
                                                        v-if="detailData.class_leader_sign"
                                                        :src="detailData.class_leader_sign"
                                                        fit="cover"
                                                        style="width: 80px;"
                                                    ></el-image>
                                                </div>
                                                <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                    <!-- <span>填表时间:</span> -->
                                                    <!-- <span style="margin-left: 10px;">{{ formData.fill_date }}</span> -->
                                                    <div style="width: 200px;">
                                                        <span>年</span>
                                                        <span style="margin: 0 40px;">月</span>
                                                        <span>日</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td class="cell table-name">
                                    <p>科</p>
                                    <p>室</p>
                                    <p>意</p>
                                    <p>见</p>
                                </td>
                                <td class="cell" colspan="8">
                                    <div>
                                        <p style="height: 100px;"></p>
                                        <div style="margin-top: 20px;">
                                            {{ detailData.department_opinions }}
                                        </div>
                                        <div>
                                            <div class="esign-info-box">
                                                <div class="esign-box">
                                                    <span style="margin-right: 120px;">负责人签字（公章）：</span>
                                                    <el-image
                                                        v-if="detailData.department_leader_sign"
                                                        :src="detailData.department_leader_sign"
                                                        fit="cover"
                                                        style="width: 80px;"
                                                    ></el-image>
                                                </div>
                                                <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                    <!-- <span>填表时间:</span> -->
                                                    <!-- <span style="margin-left: 10px;">{{ formData.fill_date }}</span> -->
                                                    <div style="width: 200px;">
                                                        <span>年</span>
                                                        <span style="margin: 0 40px;">月</span>
                                                        <span>日</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td class="cell table-name">
                                    <p>学</p>
                                    <p>校</p>
                                    <p>主</p>
                                    <p>管</p>
                                    <p>部</p>
                                    <p>门</p>
                                    <p>意</p>
                                    <p>见</p>
                                </td>
                                <td class="cell" colspan="8">
                                    <div>
                                        <p style="height: 100px;"></p>
                                        <div style="margin-top: 20px;">
                                            {{ detailData.school_competent_opinions }}
                                        </div>
                                        <div>
                                            <div class="esign-info-box">
                                                <div class="esign-box">
                                                    <span style="margin-right: 120px;">主管部门（公章）：</span>
                                                    <el-image
                                                        v-if="detailData.school_competent_department"
                                                        :src="detailData.school_competent_department"
                                                        fit="cover"
                                                        style="width: 80px;"
                                                    ></el-image>
                                                </div>
                                                <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
                                                    <!-- <span>填表时间:</span> -->
                                                    <!-- <span style="margin-left: 10px;">{{ formData.fill_date }}</span> -->
                                                    <div style="width: 200px;">
                                                        <span>年</span>
                                                        <span style="margin: 0 40px;">月</span>
                                                        <span>日</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style="margin-top: 20px;text-align: center;padding-right: 50px;">重庆医科大学继续教育学院制</div>
                </div>
            </div>
            <div v-if="is_print == 0" class="btn-box">
                <el-button type="primary" @click="editClick">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { 
    userGraduateRegInfo,
    userGraduateRegPost,
 } from "@/api/basic";
 import {userRegInfo} from '@/api/login';
import esignHandle from '@/components/esignHandle';
import {deepClone, goFirstError, getCurrentTime, timeHandle} from '@/utils/func';
import {
    outlookData,
    contactsSexFilter,
    educationLevelFilter,
} from "@/utils/baseData";
export default {
    name: 'graduateRegistForm',
    components: { esignHandle },
    inject: ['scrollTopO'],  
    filters:{
        // 性别
        sexFilter(v){
            return contactsSexFilter[v];
        },
        // 学历层次
        educationLevelFilter(v){
            return educationLevelFilter[v];
        },
    },
    data(){
        return {
            outlookList: outlookData,
            userInfo: {},
            formData: {
                id: '',
                political_status: '',  //政治面貌
                // hkmo_tw_occupant: 0,  //港/澳/台/侨 0否 1港/2澳/3台/4侨
                // health_status: '',  //健康状况 1健康 2残疾 3其他
                graduate_time: '',  //毕业时间
                work_info: '',  //工作信息
                current_work_unit: '',  //现工作单位
                position: '',  //职务
                job_title: '',  //职称
                postal_code: '',  //邮编
                detailed_address: '',  //详细通讯地址
                address_postal_code: '',  //邮政编码
                email: '',  //电子邮箱
                mobile_phone: '',  //手机号
                landline: '',  //座机
                qq_number: '',  //QQ号
                //个人主要简历
                personal_resume: [
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                ],  
                graduate_self_evaluation: '',  //毕业生自我鉴定
                graduate_self_sign: '',  //毕业生签名
                graduate_self_date: '',  //填表时间
            },
            rules: {
                political_status: [{ required: true, message: '请选择政治面貌', trigger: 'change' }],
                // hkmo_tw_occupant: [{ required: true, message: '请选择港澳台侨', trigger: 'change' }],
                // health_status: [{ required: true, message: '请选择健康状况', trigger: 'change' }],
                graduate_time: [{ required: true, message: '请填写毕业时间', trigger: 'blur' }],
                work_info: [{ required: true, message: '请填写工作信息', trigger: 'blur' }],
                current_work_unit: [{ required: true, message: '请填写现工作单位', trigger: 'blur' }],
                // position: [{ required: true, message: '请填写职务', trigger: 'blur' }],
                // job_title: [{ required: true, message: '请填写职称', trigger: 'blur' }],
                // postal_code: [{ required: true, message: '请填写邮编', trigger: 'blur' }],
                detailed_address: [{ required: true, message: '请填写详细通讯地址', trigger: 'blur' }],
                // address_postal_code: [{ required: true, message: '请填写邮政编码', trigger: 'blur' }],
                email: [{ required: true, message: '请填写电子邮箱', trigger: 'blur' }],
                mobile_phone: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
                // landline: [{ required: true, message: '请填写座机', trigger: 'blur' }],
                qq_number: [{ required: true, message: '请填写QQ号', trigger: 'blur' }],
                personal_resume: [{ required: true, message: '请填写个人简历', trigger: 'blur' }],
                graduate_self_evaluation: [{ required: true, message: '请填写毕业生自我鉴定', trigger: 'blur' }],
                graduate_self_sign: [{ required: true, message: '请填写毕业生签名', trigger: 'blur' }],
                graduate_self_date: [{ required: true, message: '请填写填表时间', trigger: 'change' }],
            },

            detailData: {
                id: '',
                admission_img: '',  //头像
                student_code: '',  //学号
                grade: '',  //年级
                study_form_title: '',  //学习形式
                profession_title: '',  //专业
                student_title: '',  //姓名
                sex: '',  //性别
                nation: '',  //民族
                political_status: '',  //政治面貌
                education_length: '',  //学制
                // hkmo_tw_occupant: 0,  //港/澳/台/侨 0否 1港/2澳/3台/4侨
                birth_date: '',  //出生日期
                // health_status: '',  //健康状况 1健康 2残疾 3其他
                education_level: '',  //学历层次
                graduate_time: '',  //毕业时间
                id_card: '',  //身份证号
                work_info: '',  //工作信息
                current_work_unit: '',  //现工作单位
                position: '',  //职务
                job_title: '',  //职称
                postal_code: '',  //邮编
                detailed_address: '',  //详细通讯地址
                address_postal_code: '',  //邮政编码
                email: '',  //电子邮箱
                mobile_phone: '',  //手机号
                landline: '',  //座机
                qq_number: '',  //QQ号
                //个人主要简历
                personal_resume: [
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                ],  
                graduate_self_evaluation: '',  //毕业生自我鉴定
                graduate_self_sign: '',  //毕业生签名
                graduate_self_date: '',  //填表时间
                class_opinions: '',  //班级意见
                class_leader_sign: '',  //班级负责人签字
                class_date: '',  //班级意见-日期
                department_opinions: '',  //科室意见
                department_leader_sign: '',  //科室意见-负责人签字（公章）
                department_date: '',  //科室意见-日期
                school_competent_opinions: '',  //学校主管部门意见
                school_competent_department: '',  //学校主管部门意见-主管部门（公章）
                school_date: '',  //学校主管部门意见-日期
            },
            is_print: 0,   //是否打印 0: 否 1: 是
            isSubmit: true,  //是否提交
        };
    },
    computed: {
        ...mapState("permission", {
            _ENTRANCETYPE: (state) => state._ENTRANCETYPE,  //成教/自考
            enterConfirm: state => state.enterConfirm,   //是否确认信息
            firstLoginVerify: state => state.firstLoginVerify,  //是否第一次登录
            // userInfoData: state => JSON.parse(state.userInfo),  //用户信息
            enterSchoolImgCheck: state => state.enterSchoolImgCheck,  //入学照审核状态
        }),
    },
    created(){
        this.getData();
        this.init();
    },
    methods: {
        // 点击修改
        editClick(){
            const {
                id,
                admission_img,  //头像
                political_status,  //政治面貌
                // hkmo_tw_occupant,  //港/澳/台/侨 0否 1港/2澳/3台/4侨
                // health_status,  //健康状况 1健康 2残疾 3其他
                graduate_time,  //毕业时间
                work_info,  //工作信息
                current_work_unit,  //现工作单位
                position,  //职务
                job_title,  //职称
                postal_code,  //邮编
                detailed_address,  //详细通讯地址
                address_postal_code,  //邮政编码
                email,  //电子邮箱
                mobile_phone,  //手机号
                landline,  //座机
                qq_number,  //QQ号
                //个人主要简历
                personal_resume,  
                graduate_self_evaluation,  //毕业生自我鉴定
                graduate_self_sign,  //毕业生签名
                graduate_self_date,  //填表时间
            } = this.detailData;
            this.formData = {
                id,
                admission_img,  //头像
                political_status,  //政治面貌
                // hkmo_tw_occupant,  //港/澳/台/侨 0否 1港/2澳/3台/4侨
                // health_status,  //健康状况 1健康 2残疾 3其他
                graduate_time,  //毕业时间
                work_info,  //工作信息
                current_work_unit,  //现工作单位
                position,  //职务
                job_title,  //职称
                postal_code,  //邮编
                detailed_address,  //详细通讯地址
                address_postal_code,  //邮政编码
                email,  //电子邮箱
                mobile_phone,  //手机号
                landline,  //座机
                qq_number,  //QQ号
                //个人主要简历
                personal_resume,  
                graduate_self_evaluation,  //毕业生自我鉴定
                graduate_self_sign,  //毕业生签名
                graduate_self_date,  //填表时间
            };
            this.isSubmit = true;
            this.scrollTopO();
        },
        // 退出
        // async exit() {
        //     // loginOut(null).then(() => {
        //     // this.$store.dispatch('permission/setIsGenerateRoutes', '');
        //     await this.$store.dispatch('permission/logOut');
        //     // Cookies.remove('token');
        //     this.$message.success('退出成功');
        //     this.$router.replace("/Login");

        //     // });
        // },
        // 提交
        confirmClick(){
            this.$refs["form"].validate(async (valid) => {
                if (valid) {
                    const data = deepClone(this.formData);
                    data.graduate_self_date = timeHandle(data.graduate_self_date, 'Y-M-D')
                    data.personal_resume = JSON.stringify(data.personal_resume);
                    userGraduateRegPost(data).then(res => {
                        if(res.code == 200){
                            this.$message.success('操作成功');
                            this.getData();
                        }
                    });
                }else{
                    goFirstError();
                }
            });
        },
        getData() {
            userRegInfo().then(res => {
                if (res.code == 200) {
                    this.userInfo = res.result; 
                    this.userInfo.graduate_time = res.result.graduation_date;
                    if(!!this.userInfo.political_status){
                        this.formData.political_status = this.userInfo.political_status;
                    }
                    if(this.userInfo.is_graduate_registration == 1){
                        this.getDetail();
                        this.isSubmit = false;
                    }
                }
            });
        },
        // 获取毕业生登记表
        getDetail() { 
            userGraduateRegInfo().then(res => { 
                // this.userInfo = res.result; 
                const {
                    id,
                    admission_img,  //头像
                    student_code,  //学号
                    grade,  //年级
                    study_form_title,  //学习形式
                    profession_title,  //专业
                    student_title,  //姓名
                    sex,  //性别
                    nation,  //民族
                    political_status,  //政治面貌
                    education_length,  //学制
                    // hkmo_tw_occupant,  //港/澳/台/侨 0否 1港/2澳/3台/4侨
                    birth_date,  //出生日期
                    // health_status,  //健康状况 1健康 2残疾 3其他
                    education_level,  //学历层次
                    graduate_time,  //毕业时间
                    id_card,  //身份证号
                    work_info,  //工作信息
                    current_work_unit,  //现工作单位
                    position,  //职务
                    job_title,  //职称
                    postal_code,  //邮编
                    detailed_address,  //详细通讯地址
                    address_postal_code,  //邮政编码
                    email,  //电子邮箱
                    mobile_phone,  //手机号
                    landline,  //座机
                    qq_number,  //QQ号
                    //个人主要简历
                    personal_resume,  
                    graduate_self_evaluation,  //毕业生自我鉴定
                    graduate_self_sign,  //毕业生签名
                    graduate_self_date,  //填表时间
                    class_opinions,  //班级意见
                    class_leader_sign,  //班级负责人签字
                    class_date,  //班级意见-日期
                    department_opinions,  //科室意见
                    department_leader_sign,  //科室意见-负责人签字（公章）
                    department_date,  //科室意见-日期
                    school_competent_opinions,  //学校主管部门意见
                    school_competent_department,  //学校主管部门意见-主管部门（公章）
                    school_date,  //学校主管部门意见-日期
                    is_print,  //是否打印
                } = res.result;

                this.detailData = {
                    id,
                    admission_img,  //头像
                    student_code,  //学号
                    grade,  //年级
                    study_form_title,  //学习形式
                    profession_title,  //专业
                    student_title,  //姓名
                    sex,  //性别
                    nation,  //民族
                    political_status,  //政治面貌
                    education_length,  //学制
                    // hkmo_tw_occupant,  //港/澳/台/侨 0否 1港/2澳/3台/4侨
                    birth_date,  //出生日期
                    // health_status,  //健康状况 1健康 2残疾 3其他
                    education_level,  //学历层次
                    graduate_time,  //毕业时间
                    id_card,  //身份证号
                    work_info,  //工作信息
                    current_work_unit,  //现工作单位
                    position,  //职务
                    job_title,  //职称
                    postal_code,  //邮编
                    detailed_address,  //详细通讯地址
                    address_postal_code,  //邮政编码
                    email,  //电子邮箱
                    mobile_phone,  //手机号
                    landline,  //座机
                    qq_number,  //QQ号
                    //个人主要简历
                    personal_resume: JSON.parse(personal_resume),  
                    // 家庭成员情况
                    graduate_self_evaluation,  //毕业生自我鉴定
                    graduate_self_sign,  //毕业生签名
                    graduate_self_date: timeHandle(graduate_self_date, 'Y年M月D日'),  //填表时间
                    class_opinions,  //班级意见
                    class_leader_sign,  //班级负责人签字
                    class_date,  //班级意见-日期
                    department_opinions,  //科室意见
                    department_leader_sign,  //科室意见-负责人签字（公章）
                    department_date,  //科室意见-日期
                    school_competent_opinions,  //学校主管部门意见
                    school_competent_department,  //学校主管部门意见-主管部门（公章）
                    school_date,  //学校主管部门意见-日期
                };
                this.is_print = is_print;
            });
        },
        // 初始化
        init(){
            this.formData.graduate_self_date = getCurrentTime(true, 'Y-M-D');
        },
    },
}
</script>

<style lang="scss" scoped>
.graduateRegistForm{
    padding: 20px;
    font-size: 16px;
    .info{
        background-color: #fff;
        padding: 20px;
        width: 1200px;
        margin: 0 auto;
        .info-box{
            .title-box{
                font-size: 24px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 20px;
            }
            .info-floor{
                display: flex;
                align-items: center;
                & + .info-floor{ 
                    margin-top: 20px;
                }
                .item{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    & + .item{
                        margin-left: 20px;
                    }
                    .name{
                        flex-shrink: 0;
                    }
                    .input{
                        margin-left: 10px;
                    }
                }
            }
            .table-box{
                margin-top: 20px;
                .table-item{
                    width: 100%;
                    .cell{
                        padding: 5px;
                        min-width: 100px;
                        &.table-name{
                            width: 40px;
                             min-width: 40px;
                            p{
                                text-align: center;
                            }
                        }
                        &.avatar{
                            width: 160px;
                            p{
                                text-align: center;
                            }
                        }
                        &.required{
                            &::before{
                                content: '*';
                                color: #EF3333;
                                margin-right: 4px
                            }
                        }
                        .esign-info-box{
                            margin-top: 10px;
                            padding-right: 20px;
                            .esign-box{
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                            }
                        }
                        .chapter{
                            padding: 0 30px;
                            text-align: center;
                        }
                    }
                }
            }
        }
        .btn-box{
            margin-top: 20px;
            text-align: center;
        }
    }
}
</style>

<style lang="scss">
.graduateRegistForm{
    .info-floor{
        .el-input{
            .el-input__inner{
                border: none;
                border-bottom: 1px solid #DCDFE6;
            }
        }
    }
    table, th, td {
        border: 1px solid #ccc;
        border-collapse: collapse;
    }
    .graduateRegistForm-student-info-box{
        table, th, td {
            border: 1px solid #ccc;
            border-collapse: collapse;
        }
        .title-box{
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            margin-top: 20px;
            margin-bottom: 40px;
        }
        .info-floor{
            width: 100%;
            display: flex;
            align-items: center;
            & + .info-floor{ 
                margin-top: 20px;
            }
            .item{
                // flex: 1;
                display: flex;
                align-items: center;
                & + .item{
                    margin-left: 20px;
                }
                .name{
                    flex-shrink: 0;
                }
                .input{
                    margin-left: 10px;
                }
            }
            .el-input{
                .el-input__inner{
                    border: none;
                    // border-bottom: 1px solid #DCDFE6;
                }
            }
        }
        .table-box{
            margin-top: 20px;
            .table-item{
                width: 100%;
                word-break: break-all;
                .cell{
                    padding: 5px;
                    // min-width: 100px;
                    &.table-name{
                        width: 40px;
                            min-width: 40px;
                        p{
                            text-align: center;
                        }
                    }
                    &.avatar{
                        width: 160px;
                        p{
                            text-align: center;
                        }
                    }
                    &.required{
                        &::before{
                            content: '*';
                            color: #EF3333;
                            margin-right: 4px
                        }
                    }
                    .esign-info-box{
                        margin-top: 10px;
                        padding-right: 20px;
                        .esign-box{
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                        }
                    }
                    .chapter{
                        padding: 0 30px;
                        text-align: center;
                    }
                }
            }
        }
    }
}
</style>